import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import { HttpStatusCode } from 'constants/globals';

import {
  adaptDataToGenericResponse,
  adaptErrorToGenericResponse,
  ApiResponse,
} from '../shared';

import type { BasicPersonIdentityDto } from './dto';
import { mapBasicPersonIdentityApiResponseDtoToModel } from './mappers';
import type { BasicPersonIdentity } from './models';

export const validateDuplicatedRFC = async (
  rfc: string,
): Promise<GenericResponse<ApiResponse<BasicPersonIdentity>>> => {
  try {
    const { data, status } = await wtClientApi.get<
      ApiResponse<BasicPersonIdentityDto>
    >('/onboarding/validator', { params: { rfc } });

    if (status === HttpStatusCode.OK) {
      return {
        ...adaptDataToGenericResponse(
          mapBasicPersonIdentityApiResponseDtoToModel(data),
          status,
        ),
        success: false,
        errorMessage: 'El RFC ingresado ya se encuentra registrado.',
      };
    }
    return adaptDataToGenericResponse<ApiResponse<BasicPersonIdentity>>(
      null,
      status,
    );
  } catch (error: any) {
    const status = error?.response?.status;

    if (status === HttpStatusCode.NotFound) {
      return adaptDataToGenericResponse<ApiResponse<BasicPersonIdentity>>(
        null,
        status,
      );
    }

    return adaptErrorToGenericResponse<ApiResponse<BasicPersonIdentity>>(
      error,
      'No se pudo verificar el RFC',
    );
  }
};
